<template>
<div>
    <v-text-field
        :label=label
        :value="value_text"
        disabled
        autocomplete="off"
        v-if="!multiple"
    >

        <span
            slot="append-outer"
        >
            <m-edit-menu
                v-if="!read_only"
                :menu_items="menu_items"
                v-on:menu-action="onMenuAction($event)"
            />

        </span>


    </v-text-field>

    <div
        v-if="multiple"
        style="display: flex"
    >
        <div
            style="border-bottom: 1px dotted rgba(0,0,0,0.25); padding-bottom: 5px; flex-grow: 1"
        >
            <v-chip
                v-for="(item, index) in selected_values"
                :key="'sc_'+index"
                :close="!read_only"
                style="margin-right: 7px"
                v-on:click:close="remove(item.value)"
            >
                {{item.text}}
            </v-chip>
        </div>

        <div
            style="flex-grow: 0; margin-left: 10px; margin-top: 10px"
        >
            <v-icon
                color="primary"
                v-on:click="onEdit"
                v-if="!read_only"
            >
                mdi-lead-pencil
            </v-icon>
        </div>

    </div>


    <m-edit-select-dialog
            ref="edit-dialog"
            v-on:ok="setValue($event)"
            :multiple="multiple"
            :chips="multiple"
            :return-object="returnObject"
    />


</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {

        label: {
            type: String,
            default: function () { return ''; }
        },

        value: {
            type: [Object, String, Array],
            default: function() { return { 'text' : 'Some Choice' }; }
        },

        possible_values: {
            type: Array,
            default: function() { return []; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        menu_items: {
            type: Array,
            default: function() { return []; }
        },

        multiple: {
            type: Boolean,
            default: function() { return false; }
        },

        'return-object': {
            type: Boolean,
            default: function() { return true; }
        },
    },

    methods: 
    {
        onMenuAction(menu_item)
        {
            if ( menu_item.event == 'edit' )
            {
                this.onEdit();
                return;
            }

            this.$emit(menu_item.event, menu_item);
        },

        onEdit() 
        {
            this.$refs['edit-dialog'].showDialog(this.label, this.value, this.possible_values);
        },

        setValue(new_value)
        {
            this.$emit('input',new_value);
        },

        remove(value_to_remove)
        {
            let new_value = this.value.filter((el) => el != value_to_remove);
            this.$emit('input', new_value);
        },
    },

    computed: {
        value_text() 
        {
            let value = this.value;

            if ( value == null ) return null;

            if ( typeof value === 'string')
            {
                let pv = this.possible_values;

                for ( let i = 0; i < pv.length; i++ )
                {
                    if ( pv[i].value == value )
                        return pv[i].text;
                }
            }

            return value.text;
        },

        selected_values()
        {
            return this.possible_values.filter((el) => this.value.includes(el.value));
        },
    },
}
</script>

<style lang="scss" scoped>

</style>